(ns ui.editors.card.shared.sortable-field-list
  (:require
   [common.localization :as loc]
   [ui.components.button.view :as button]
   [ui.components.select.select :as select]
   [ui.components.sortable-list.view :as sortable-list]))

(defn view
  [{:keys [selected-options available-options
           remove-field add-field reorder-items]}]
  [:div
   {:class "flex flex-col gap-2"}
   [sortable-list/view
    {:items selected-options
     :get-key :value
     :gap 8
     :on-reorder (fn [{:keys [source-index destination-index]}]
                   (reorder-items source-index destination-index))

     :container-class "pt-2"
     :render-item (fn [{:keys [item]}]
                    (let [{:keys [label value]} item]
                      [:div
                       {:class "flex gap-3 items-center rounded px-2 py-2 bg-base-light border border-solid border-base-light-border-paler hover:border-base-light-border-accent cursor-default"}
                       [:div
                        {:class "cursor-grab"}
                        [sortable-list/drag-handle-icon]]
                       [:div
                        {:class "grow"}
                        [:p
                         {:class "text-sm m-0"}
                         label]]
                       [:div
                        [button/square-secondary-open
                         {:class    "group"
                          :on-click #(remove-field value)}
                         [:i.fal.fa-trash
                          {:class "group-hover:text-danger-regular text-xs m-0"}]]]]))}]
   #_[dnd-list/dnd-list
      {:keyed-items
       (->> selected-options
            (mapv (fn [{:keys [value] :as opt}]
                    {:key  value
                     :item opt})))
       :on-drag-end reorder-items
       :render-item-fn
       (fn [[_ {:keys [item]}]]
         (let [{:keys [label value]} item]
           [:div
            {:class "flex gap-3 items-center rounded-sm px-3 py-2 border border-solid border-base-light-border-paler hover:border-base-light-border-accent cursor-default"}
            [:div
             {:class "flex items-center py-2 px-2 cursor-grab bg-complement-regular hover:bg-primary-regular rounded"}
             [:i.fas.fa-grip-vertical.text-xs]]
            [:div
             {:class "grow"}
             [:p
              {:class "text-sm m-0"}
              label]]
            [:div
             [button/square-secondary-open
              {:class    "group"
               :on-click #(remove-field value)}
              [:i.fal.fa-trash
               {:class "group-hover:text-danger-regular text-xs m-0"}]]]]))}]
   [select/view
    {:options     available-options
     :placeholder (loc/tr :add-field)
     :on-change   add-field}]])
